export default "__VITE_ASSET__Cp5BYjWU__"